import { CARRIER_CONSTRAINTS } from './constraints.js';
/** A tracking link is useless without a spot for the tracking number, so a non-empty one must contain the placeholder. */
export function trackingUrlProblem(trackingUrl) {
    if (!trackingUrl)
        return null;
    const { placeholder } = CARRIER_CONSTRAINTS.trackingUrl;
    return trackingUrl.includes(placeholder)
        ? null
        : `Put ${placeholder} where the tracking number goes.`;
}
//# sourceMappingURL=tracking-url-problem.js.map